// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var ReasonReact = require("reason-react/src/ReasonReact.js");
var Logo$ReasonProfile = require("./Logo.bs.js");
var FontAwesomeIcon$ReasonProfile = require("../../common/font-awesome/FontAwesomeIcon.bs.js");

require('./SkillTile.css')
;

var component = ReasonReact.statelessComponent("SkillTile");

function make(name, logo, star, _children) {
  return {
          debugName: component.debugName,
          reactClassInternal: component.reactClassInternal,
          handedOffState: component.handedOffState,
          willReceiveProps: component.willReceiveProps,
          didMount: component.didMount,
          didUpdate: component.didUpdate,
          willUnmount: component.willUnmount,
          willUpdate: component.willUpdate,
          shouldUpdate: component.shouldUpdate,
          render: (function (_self) {
              return React.createElement("div", {
                          className: "SkillTile"
                        }, React.createElement("div", {
                              className: "SkillTile-label"
                            }, React.createElement("div", {
                                  className: "SkillTile-text"
                                }, name + " ", star ? ReasonReact.element(undefined, undefined, FontAwesomeIcon$ReasonProfile.make(/* :: */[
                                            "fas",
                                            /* :: */[
                                              "star",
                                              /* [] */0
                                            ]
                                          ], undefined, "SkillTile-icon-star", undefined, undefined, undefined, /* array */[])) : null)), React.createElement("div", {
                              className: "SkillTile-image-block"
                            }, React.createElement("div", {
                                  className: "SkillTile-image-cell"
                                }, React.createElement("img", {
                                      className: "SkillTile-image",
                                      alt: name,
                                      src: Logo$ReasonProfile.get(logo)
                                    }))));
            }),
          initialState: component.initialState,
          retainedProps: component.retainedProps,
          reducer: component.reducer,
          jsElementWrapped: component.jsElementWrapped
        };
}

exports.component = component;
exports.make = make;
/*  Not a pure module */
